var _rect, _g, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenTickBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 102,
    viewBox: "0 0 103 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.98975,
    y: 8,
    width: 86,
    height: 86,
    rx: 43,
    fill: "#A6F4C5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_11034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.4898 50.39V52C70.4876 55.7737 69.2656 59.4457 67.0061 62.4682C64.7465 65.4907 61.5705 67.7018 57.9516 68.7718C54.3327 69.8418 50.4649 69.7133 46.9251 68.4055C43.3852 67.0977 40.3629 64.6807 38.3089 61.5149C36.255 58.3491 35.2794 54.6041 35.5277 50.8386C35.776 47.073 37.2349 43.4886 39.6867 40.6199C42.1386 37.7512 45.4521 35.7519 49.1331 34.9203C52.814 34.0886 56.6652 34.4691 60.1123 36.005M70.4898 38L52.9898 55.5175L47.7398 50.2675",
    stroke: "#039855",
    strokeWidth: 5.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.98975,
    y: 8,
    width: 86,
    height: 86,
    rx: 43,
    stroke: "#ECFDF3",
    strokeWidth: 16
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_11034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(31.9897 31)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickBig);
export default __webpack_public_path__ + "static/media/green-tick-big.27fe43ccdf46c25d451189cf22f76298.svg";
export { ForwardRef as ReactComponent };